<div class="container app-header fixed-top">
  <div class="row h5 pt-2 pb-2 mb-0 align-items-center">
    <!--<div class="col-auto pl-1 pr-0">
      <button class="btn" [routerLink]="['/menu']"><i class="fa fa-bars"></i></button>
    </div>-->
    <div class="col text-truncate"><a class="home-link" [routerLink]="['']">{{ host?.name }}</a></div>
    <div class="col-auto pr-2">
      <button class="btn btn-primary" [routerLink]="['/search']">
        <i class="fa fa-search"></i>
      </button>
      <button id="checkout-button" class="btn btn-warning ml-3"
              [routerLink]="['/checkout/start']"
              [disabled]="cart.getCount()==0"
              [@countChange]="cart.getCount()"
              *ngIf="cart && ordersEnabled">
        <i class="fa fa-shopping-cart"></i>&nbsp;<span *ngIf="cart.getCount()">{{ cart.getCount() }}</span>
      </button>
    </div>
  </div>
</div>
